import { Platform } from "react-native";
import AppConfig from "../../config/AppConfig";

const isIos = Platform.OS === "ios";

//const prefix = __DEV__ ? "http" : "https";

const wrapperPart = () => {
    const baseHtml = `<!DOCTYPE html>
<html lang="en">
	<head>
		<meta charset="utf-8" />
		<meta content="IE=edge" http-equiv="X-UA-Compatible" />
		<meta content="width=device-width, initial-scale=1" name="viewport" />
		<script src="%sitebase%/node_modules/hanzi-writer/dist/hanzi-writer.min.js"></script>
		<script>
		  function aichinese_postMessage(payloadStr) {
		    if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(payloadStr);
            } else if (window.parent) {
                window.parent.postMessage(payloadStr, '*');
            } else {
                window.postMessage(payloadStr, '*');
            }
		  }
        </script>
	</head>
	<body>
	    %body%
	</body>
</html>`;

    return baseHtml.replace(/%sitebase%/g, AppConfig.SITE_BASE);
};

const fontLoadPart = () => {
    const fontLoadFnStr = `charDataLoader: function(char, onComplete) {
                        fetch("%sitebase%/node_modules/hanzi-writer-data/" + char + ".json") // Call the fetch function passing the url of the API as a parameter
                        .then(function(charData) {
                            // Your code for handling the data you get from the API
                            onComplete(charData.json());
                        })
                        .catch(function() {
                            // This is where you run code if the server returns any errors, backup fetch
                            fetch("https://cdn.jsdelivr.net/npm/hanzi-writer-data@2.0/" + char + ".json").then(function(charData2) {
                                // Your code for handling the data you get from the API
                                onComplete(charData2.json());
                            })
                        });
                    },`;

    return fontLoadFnStr.replace(/%sitebase%/g, AppConfig.SITE_BASE);
};

const getPOLA1BaseHtml = bgWidth => {
    const bgHalfWidth = bgWidth / 2;
    const baseWrapper = wrapperPart();
    const fontLoadStr = fontLoadPart();
    //POLA1 case
    let body = `
		<style>
			body {
				display: flex;
				font-size: 2em;
				justify-content: center;
				align-items: center;
			}
			.inline-demo-console {
				font-family: monospace;
				font-size: 10px;
				border: 1px solid #ccc;
				width: 300px;
				height: 150px;
				padding-left: 5px;
				overflow-y: scroll;
				display: none;
			}
		</style>

		<div style="display: flex; justify-content: center;">
			<svg xmlns="http://www.w3.org/2000/svg" width=${bgWidth} height=${bgWidth} id="grid-background-target" style="border: 1px solid #ddd;">
				<line x1="0" y1="0" x2=${bgWidth} y2=${bgWidth} stroke="#DDD" />
				<line x1=${bgWidth} y1="0" x2="0" y2=${bgWidth} stroke="#DDD" />
				<line x1=${bgHalfWidth} y1="0" x2=${bgHalfWidth} y2=${bgWidth} stroke="#DDD" />
				<line x1="0" y1=${bgHalfWidth} x2=${bgWidth} y2=${bgHalfWidth} stroke="#DDD" />
			</svg>
		</div>
		<br />
		<script type="text/javascript">
			(function () {
				var writer = HanziWriter.create(document.getElementById("grid-background-target"), "%char%", {
					width: ${bgWidth},
					height: ${bgWidth},
					padding: 5,
					showCharacter:false,
					showOutline: true,
					strokeColor: "#33cc66", //写对了以后的颜色，默认黑色
					highlightColor: "#ff3300",  //写错了的提示颜色，默认是紫色
					showHintAfterMisses: 1,   //写错几次提示正确的笔顺，默认是3次
					highlightOnComplete: false,
					onLoadCharDataSuccess: function (data) {
						console.log("Success!");
					},
					onLoadCharDataError: function (reason) {
						console.log("Oh No! Something went wrong :(");
					},
                    %fontload%
				});

				var opts = {
					onMistake: function (strokeData) {
                        aichinese_postMessage("fail");
					},
					onCorrectStroke: function (strokeData) {
                        aichinese_postMessage("correct");
					},
					onComplete: function (summaryData) {
                        aichinese_postMessage("complete");
					},
				};
				writer.quiz(opts);

                window.addEventListener("message", function (event) {
                    switch (event.data) {
                        case "animate":
                            writer.animateCharacter({
                                onComplete: function() {
                                  writer.quiz(opts);
                                  aichinese_postMessage("playend");
                                }
                            });
                            break;
                        case "quiz":
                            writer.quiz(opts);
                            break;
                        default:
                            break;
                   }
                });

			})();
		</script>
`;

    return baseWrapper.replace(/%body%/g, body).replace(/%fontload%/g, fontLoadStr);
};

const getBottomPopExplanationBaseHtml = () => {
    const baseWrapper = wrapperPart();
    const fontLoadStr = fontLoadPart();
    let body = `
	<body>
	    <style>
            body {
                /*display: flex;*/
                /*font-size: 2em;*/
                /*justify-content: center;*/
                /*align-items: center;*/
            }
            .inline-demo-console {
                font-family: monospace;
                font-size: 10px;
                border: 1px solid #ccc;
                width: 120px;
                height: 120px;
                padding-left: 5px;
                overflow-y: scroll;
                display: none;
            }
        </style>
		<div style="display: flex; justify-content: center;">
			<svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" id="grid-background-target" style="border: 1px solid #ddd;">
				<line x1="0" y1="0" x2="120" y2="121" stroke="#DDD" />
				<line x1="113" y1="0" x2="0" y2="115" stroke="#DDD" />
				<line x1="58" y1="0" x2="58" y2="120" stroke="#DDD" />
				<line x1="0" y1="60" x2="120" y2="60" stroke="#DDD" />
			</svg>
		</div>
		<br />
		<script type="text/javascript">
			(function () {
				var writer = HanziWriter.create(document.getElementById("grid-background-target"), "%char%", {
					width: 115,
					height: 115,
					showOutline: true,
					onLoadCharDataSuccess: function (data) {
						console.log("Success!");
					},
					onLoadCharDataError: function (reason) {
						console.log("Oh No! Something went wrong :(");
					},
					%fontload%
				});
				writer.loopCharacterAnimation();
			})();
		</script>
`;

    return baseWrapper.replace(/%body%/g, body).replace(/%fontload%/g, fontLoadStr);
};

const getWritingBoardHtml = () => {
    const baseWrapper = wrapperPart();
    const fontLoadStr = fontLoadPart();

    let body = `
		<style>
			body {
				/*display: flex;*/
				/*font-size: 2em;*/
				/*justify-content: center;*/
				/*align-items: center;*/
			}
			.inline-demo-console {
				font-family: monospace;
				font-size: 10px;
				border: 1px solid #ccc;
				width: 300px;
				height: 150px;
				padding-left: 5px;
				overflow-y: scroll;
				display: none;
			}
		</style>

		<div style="display: flex; justify-content: center;">
			<svg xmlns="http://www.w3.org/2000/svg" width="300" height="300" id="grid-background-target" style="border: 1px solid #ddd;">
				<line x1="0" y1="0" x2="300" y2="300" stroke="#DDD" />
				<line x1="300" y1="0" x2="0" y2="300" stroke="#DDD" />
				<line x1="150" y1="0" x2="150" y2="300" stroke="#DDD" />
				<line x1="0" y1="150" x2="300" y2="150" stroke="#DDD" />
			</svg>
		</div>
		<br />
		<script type="text/javascript">
			(function () {
				var writer = HanziWriter.create(document.getElementById("grid-background-target"), "%char%", {
					width: 300,
					height: 300,
					padding: 5,
                    showCharacter:false,
					showOutline: true,
					strokeColor: "#33cc66", //写对了以后的颜色，默认黑色
                    highlightColor: "#ff3300",  //写错了的提示颜色，默认是紫色
                    showHintAfterMisses: 1,   //写错几次提示正确的笔顺，默认是3次
                    highlightOnComplete: false,
					onLoadCharDataSuccess: function (data) {
						console.log("Success!");
					},
					onLoadCharDataError: function (reason) {
						console.log("Oh No! Something went wrong :(");
					},
					%fontload%
				});

				var opts = {
					onMistake: function (strokeData) {
                        aichinese_postMessage("fail");
					},
					onCorrectStroke: function (strokeData) {
                        aichinese_postMessage("correct");
					},
					onComplete: function (summaryData) {
                        aichinese_postMessage("complete");
					},
				};
                
                window.addEventListener("message", function (event) {
                    switch (event.data) {
                       case "animate":
                           writer.animateCharacter();
                           break;
                       case "quiz":
                           writer.quiz(opts);
                           break;
                       default:
                           break;
                   }
                });

			})();
		</script>
`;

    return baseWrapper.replace(/%body%/g, body).replace(/%fontload%/g, fontLoadStr);
};

export { getPOLA1BaseHtml, getBottomPopExplanationBaseHtml, getWritingBoardHtml };
